import { stateToParams as kpiToParams } from "@/pages/company-kpi/_shared/kpi/url-state";
import { Kpi } from "@/types/proto/exabel/kpi/kpi_messages";

// Inlined from lib/paths/paths (not copied to ADC)
const addQueryString = (url: string, query?: string) =>
  query ? `${url}?${query}` : url;

export const companyKpi = (entityResourceName: string, selectedKpi?: Kpi) =>
  addQueryString(
    `/view/${entityResourceName}`,
    selectedKpi ? kpiToParams({ selected: selectedKpi }) || "" : undefined
  );
